
<section
role="dialog"
aria-modal="true"
aria-labelledby="modal-title"
class="inset-0 z-10 fixed overflow-y-auto"
>
<div class="flex flex-col h-full text-center p-4 items-center justify-center">
  <div
    aria-hidden="true"
    class="bg-gray-500 bg-opacity-75 inset-0 transition-opacity fixed"
  ></div>

  <div
    class="bg-white rounded-lg shadow-xl text-left w-full transform transition-all overflow-y-auto sm:max-w-screen-sm sm:my-8"
  >
    <section class="p-8">

      
    <form ngNativeValidate 
    id="biodata-education" (ngSubmit)="addToCart()"
    class="max-w-screen-md grid gap-8 grid-cols-1">
    <h1 class="font-medium text-lg mb-1">{{shopItem.ShopItemName}}</h1>

    <div class="border-primary-lighter border-b-2 grid pb-1 gap-4 grid-cols-1">
      <app-notification-alert [data]="apiService.notification"></app-notification-alert>

      
      <label *ngIf="sizeOptions.length > 1 || (sizeOptions.length == 1 && itemSize)" class="block">
        <div class="font-medium text-grey-darker text-sm pb-1">
          Size
        </div>
        <select 
        name="size"
        [(ngModel)]="itemSize" 
        (change)="sizeChanged($event)"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 focus:outline-none focus-within:border-primary-light">
          <option disabled [value]="defaultValue">Select Size</option>
          <option *ngFor="let item of sizeOptions" 
          [value]="item" 
          [selected]="item == itemSize">
            {{ getSelectOptionLabel(item) }}
          </option>
        </select>
      </label>
      
      <label *ngIf="colourOptions.length > 1 || (colourOptions.length == 1 && itemColour)" class="block">
        <div class="font-medium text-grey-darker text-sm pb-1">
          Colour
        </div>
        <select 
        name="colour"
        [(ngModel)]="itemColour" 
        (change)="colourChanged($event)"
        class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 focus:outline-none focus-within:border-primary-light">
          <option disabled [value]="defaultValue">Select Colour</option>
          <option *ngFor="let item of colourOptions" 
          [value]="item" 
          [selected]="item == itemColour">
            {{ getSelectOptionLabel(item) }}
          </option>
        </select>
      </label>

      <label class="block">
        <div class="font-medium text-grey-darker text-sm pb-1">
          Quantity
        </div>
        <input
          required
          type="number" min="0" step="1"
          name="quantity" 
          [(ngModel)]="quantity"
          class="border border-primary-lighter rounded text-sm w-full py-2 px-3 text-gray-700 appearance-none focus:outline-none focus-within:border-primary-light"
        />
    </label>
    
    <div class="pb-1 grid gap-4 grid-cols-2">
      <div class="">
        <small>Unit Price</small><br>
        <small>Quantity</small><br>
        <small><b>Total</b></small>
      </div>
      <div class="text-right">
        <small>₦{{(selectedShopItem?.PricePerQuantity ?? 0).toLocaleString()}}</small><br>
        <small>{{(quantity || 0)}}</small><br>
        <small><b>₦{{((selectedShopItem?.PricePerQuantity ?? 0) * quantity).toLocaleString()}}</b></small>
      </div>
    </div>
    
    </div>

    <nav class="flex flex-col py-2 gap-4">
      <div class="grid py-1 gap-8 grid-cols-1 md:grid-cols-2">
        <app-button-primary type="button" class="w-full" [outline]="true" [disabled]="loading" 
        (click)="closeModal()">
          <div>CANCEL</div>
        </app-button-primary>

        <app-button-primary [disabled]="loading || !selectedShopItem || quantity <= 0" type="submit">
          ADD TO CART
        </app-button-primary>
      </div>

    </nav>
   
  </form>
    </section>
  </div>
</div>
</section>

<!-- 
<div class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 rounded-lg shadow-lg p-4 w-80 z-50">
  <form (ngSubmit)="addToCart()" class="flex flex-col">
    <app-notification-alert [data]="apiService.notification"></app-notification-alert>
    <h1 class="font-medium text-center text-lg mb-4">{{shopItem.ShopItemID}}</h1>

    
    
    
    <div *ngIf="sizeOptions.length != 0" class="w-full p-1 mb-4">
      <select [disabled]="sizeOptions.length == 1" [(ngModel)]="itemSize" name="size" (change)="sizeChanged($event)"
      class="w-full p-1 border border-primary rounded-md focus:outline-none">
        <option disabled [value]="defaultValue">Select Size</option>
        <option *ngFor="let item of sizeOptions" [value]="item">{{ getSelectOptionLabel(item) }}</option>
      </select>
    </div>

    <div *ngIf="colourOptions.length != 0" class="w-full p-1 mb-4">
      <select [disabled]="colourOptions.length == 1" [(ngModel)]="itemColour" name="colour" (change)="colourChanged($event)" 
      class="w-full p-1 border border-primary rounded-md focus:outline-none">
        <option disabled [value]="defaultValue">Select Colour</option>
        <option *ngFor="let item of colourOptions" [value]="item">{{ getSelectOptionLabel(item) }}</option>
      </select>
    </div>

    <div class="w-full p-1 mb-4">
      <input [(ngModel)]="quantity" name="quantity"
      class="w-full p-1 border border-primary rounded-md focus:outline-none"
      required
      />
    </div>

    <p>{{selectedShopItem?.Amount ?? 0}} * {{quantity}} = {{(selectedShopItem?.Amount ?? 0) * quantity}}</p>
    
    

  </form>
</div> -->
